export const SAVED_STATE = {
    ENVIRONMENT: 'vision9.solar.environment',
    TOKEN: 'vision9.solar.token',
    UNIQUE_ID: 'vision9.solar.uniqueId',
    LIST_VIEW: 'vision9.solar.listView',
    SAVED_PATH: 'vision9.solar.savedPath',
};
